module.exports = __webpack_public_path__ + "img/Metrics.aff65435.svg";